module.exports = __webpack_public_path__ + "media/custom/images/img11-ca3b9193bd198cd6d4517cc51c1e2ae1.png";